import { ECOMMERCE_ITEM_BENEFIT_TYPE } from '@/types/shared/player-config'
import CoinIcon from '@/assets/images/icons/gold-coin-icon-s3.webp'
import fortuneWheelImage from '@/assets/images/fortune-wheel.webp'
import tphx2Image from '@/assets/images/prize-cards/php2x.webp'
import offlineProfitImage from '@/assets/images/offline-profit.png'
import premiumImage from '@/assets/images/premium.png'
import ticketImage from '@/assets/images/emojis/emoji-ticket.png'

export const benefitConfigMap: Record<string, { image: string; alt: string }> = {
  coin: {
    image: CoinIcon,
    alt: 'Coin',
  },
  spin: {
    image: fortuneWheelImage,
    alt: 'Fortune wheel',
  },
  tphx2: {
    image: tphx2Image,
    alt: 'TPH x2',
  },
  offlineProfit: {
    image: offlineProfitImage,
    alt: 'Offline profit',
  },
  star: {
    image: premiumImage,
    alt: 'Stars',
  },
  ticket: {
    image: ticketImage,
    alt: 'Giveaway Ticket',
  },
}

export const benefitTypeToKey: Partial<Record<ECOMMERCE_ITEM_BENEFIT_TYPE, string>> = {
  [ECOMMERCE_ITEM_BENEFIT_TYPE.GOLDEN_COIN]: 'coin',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.SPIN]: 'spin',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.PROFIT_X2]: 'tphx2',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.OFFLINE_PROFIT]: 'offlineProfit',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.STAR]: 'star',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.SPECIAL_CURRENCY]: 'specialCurrency',
  [ECOMMERCE_ITEM_BENEFIT_TYPE.GIVEAWAY_TICKET]: 'ticket',
}

export const benefitOrder: ECOMMERCE_ITEM_BENEFIT_TYPE[] = [
  ECOMMERCE_ITEM_BENEFIT_TYPE.GOLDEN_COIN,
  ECOMMERCE_ITEM_BENEFIT_TYPE.SPIN,
  ECOMMERCE_ITEM_BENEFIT_TYPE.PROFIT_X2,
  ECOMMERCE_ITEM_BENEFIT_TYPE.OFFLINE_PROFIT,
  ECOMMERCE_ITEM_BENEFIT_TYPE.STAR,
  ECOMMERCE_ITEM_BENEFIT_TYPE.SPECIAL_CURRENCY,
  ECOMMERCE_ITEM_BENEFIT_TYPE.GIVEAWAY_TICKET,
]
